<!-- Implement a custom banner, the cortex one does not have a custom icon -->
@if (dialog()?.data?.annotations) {
<div class="banner">
  <cw-icon icon="message-reminder" font="cortex" />
  {{ dialog()?.data?.annotations }}
</div>
} @if (dialog()?.data?.patient) {
<div
  [innerHTML]="'TherapyJobAbortText' | translate : { patientName: dialog().data.patient | personName } | safeHtml"
></div>
} @if (form()) {
<form class="form" [formGroup]="form()">
  <gplus-textarea
    class="full-group"
    [required]="true"
    [label]="'TherapyJobAbortedTextareaLabel' | translate"
    [control]="form().controls['abortReason']"
    [maxLength]="abortReasonMaxLength"
    [validations]="{
      maxlength: 'TextareaMaxCharactersError' | translate,
      required: 'TherapyJobFinishInputRequired' | translate
    }"
  />
</form>
}

<div class="actions-btns">
  <cw-button button-color="secondary" variant="outlined" (click)="closeDialog()">
    {{ 'TherapyJobAbortCloseButton' | translate }}
  </cw-button>

  @if(form().invalid){

  <!-- Disabled -->
  <cw-tooltip
    [content]="(form()?.controls?.['abortReason']?.hasError('maxlength') ? 'TherapyJobFinishDisabledSubmitErrorTooltip': 'TherapyJobFinishDisabledSubmitRequiredTooltip') | translate"
    placement="bottom"
  >
    <cw-button button-color="accent" variant="filled" [disabled]="true" type="submit">
      {{ 'TherapyJobAbortSubmitButton' | translate }}
    </cw-button>
  </cw-tooltip>

  } @else{
  <!-- Enabled -->
  <cw-button button-color="accent" variant="filled" (click)="submitChange()" type="submit">
    {{ 'TherapyJobAbortSubmitButton' | translate }}
  </cw-button>
  }
</div>
